module.exports = __webpack_public_path__ + "static/media/go_dukes_light.26ce09ed.svg";